var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M595.5,186c-4.2-4.2-9.6-6.5-15.2-6.5c-5.6,0-11,2.3-15.2,6.5l-280,280.9L135.7,317.5c-4.2-4.2-9.6-6.5-15.2-6.5 s-11,2.3-15.2,6.5c-4.2,4.2-6.5,9.6-6.5,15.2c0,5.6,2.3,11,6.5,15.2l165.6,165.6l0.2,0.2l0.1,0.1c3.3,2.4,7.8,5.3,13.9,5.3 c6.1,0,10.7-2.8,14-5.3l0.1-0.1l296.3-297.2C604.2,207.7,604.2,194.7,595.5,186z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.4b7405dafb36e74fe75253505de094d5.svg";
export { ForwardRef as ReactComponent };